module.exports = __webpack_public_path__ + "03_mole.83cdbb09.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer2/03_mole.png
// module id = 9gZb
// module chunks = 0